<template>
    <div class="bg-wrap" :style="{height: bodyHeight + 'px'}">
        <Banner></Banner>
        <div class="login-wrap">
                    <div class="item">
                        <input type="text" v-model="field.phone" maxlength="11" placeholder="手机号">
                    </div>
                    <div class="item">
                        <input type="password" v-model="field.code" maxlength="6" placeholder="验证码">
                        <span class="enable" @click="handleGetMess" v-if="countdown==0">{{getCodeInfo}}</span>
                        <span  class="disable" v-if="countdown!=0">{{countdown}}S</span>
                    </div>

            <div class="agreement">
                <span class="c check" v-if="check" @click="check=!check"></span>
                <span class="c uncheck" v-else @click="check=!check"></span>
                <label>我已阅读并同意</label>
                <label class="b" @click="$router.push('docPrivacy')">{{p1}}</label>
            </div>

            <div class="btn" @click="handleSubmit(field.phone,field.code,openid)">
                <label>{{login}}</label>
            </div>
        </div>
<!--        <div class="bottom">-->
<!--            <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/bottom_1.png">-->
<!--        </div>-->
    </div>
</template>

<script>
    import {checkMobile,isMobile} from "@/assets/util/util";
    import {ksdDocGetCode, ksdDocLoginByCode,ksdDocLoginByOpenid} from "@/assets/js/api";
    import {openId} from "@/assets/js/api";
    import Banner from "@/components/ksd/fragment/Banner";

    export default {
        data() {
            return {
                countDown: 60, // 倒计时60秒
                getState:1,
                getCodeInfo:"获取验证码",
                login:"登录",
                countdown:0,
                field: {
                    phone: "",
                    code: "", //手机验证码
                },
                bodyHeight:"",
                code:this.$route.query.code,
                openid:null,
                p1:"《知情同意书》",
                check:false
            };
        },
        components:{
          Banner
        },
        mounted(){
            this.bodyHeight = document.documentElement.clientHeight
            /**
             * 1:先获取code
             * 2：根据code获取openid
             * 3：根据openid登录
             *   3.1：登录成功，跳转首页
             */
            // 获取openid
            if(this.code!=null){
                this.getOpenId(this.code)
            }else{
                if(isMobile()){//移动端重定向，把code带回来
                    let url = "http://app.iumed.com.cn/docLogin"
                    window.location.replace("http://tang.iumed.com.cn?url="+url)
                }
            }
        },
        methods: {
            async getOpenId(code){
                const res = await openId({code})
                if(res.data.success){
                    this.openid= res.data.openId;
                    await this.loginByOpenId(this.openid)
                }
            },
            // 调用短信验证码接口
            async handleGetMess() {
                const { phone} = this.field;
                if (!phone) {
                    this.$toast("手机号不得为空");
                    return;
                }
                if (!checkMobile(phone)) {
                    this.$toast("请输入正确的手机号");
                    return;
                }
                if(this.countdown>0){
                    return
                }
                this.getCode(phone)
            },
            async handleSubmit(phone,code,openid) {
                if (!phone) {
                    this.$toast("手机号不得为空");
                    return;
                }
                if (!checkMobile(phone)) {
                    this.$toast("请输入正确的手机号");
                    return;
                }
                if(!code){
                    this.$toast("验证码不得为空");
                    return;
                }
                if(!this.check){
                    this.$toast("请阅读知情同意");
                    return;
                }
                const res = await ksdDocLoginByCode({phone,code,openid})
                if(!res.data.success){//登录失败
                    this.$toast(res.data.message)
                }else{//登录成功
                    this.$store.state.ksd_docId = res.data.data.docId
                    this.$router.push("docIndex")

                }
            },
            async loginByOpenId(openid){
                    const res = await ksdDocLoginByOpenid({openid});
                    if(res.data.success){
                        this.$store.state.ksd_docId = res.data.data.docId
                        // this.$router.replace("docIndex")
                        // if(res.data.data.privacy==0){
                        //     this.$router.push("docPrivacy")
                        // }else{
                        //     this.$router.push("docIndex")
                        // }

                        this.$router.push("docIndex")

                    }
            },
            countdownSecond(){
                if(this.countdown==0){
                    this.countdown=60
                }
                // 倒计时
                const countDown60 = setInterval(() => {
                    if(this.countdown>0){
                        this.countdown--
                    }
                    if(this.countdown<=0){
                        clearInterval(countDown60);
                    }
                }, 1000);
            },
            async getCode(phone){
                const res = await ksdDocGetCode({phone})
                if(!res.data.success){
                    this.$toast(res.data.message)
                }else{
                    this.$toast("验证码已发送")
                    this.countdownSecond()
                }
            }
        }
    };
</script>

<style scoped lang="scss">
    .bg-wrap {
        width: 100%;
        height: 100vh;
        background: #fff url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/bg.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        flex-flow: column;
        font-size: 16px;
    }
    .login-wrap{
        margin: 0 auto;
        width: 85%;
    }
    .login-wrap .item{
        border: #2c9a58 1px solid;
        display: flex;
        flex-flow: row;
        align-items: center;
        margin-bottom: 10px;
        border-radius: 5px;
        padding: 2px;
    }
    .login-wrap .item input{
        border: none;
        outline: none;
        flex-grow: 1;
        height: 23px;
        text-indent: 5px;
        font-size: 15px;
    }
    .login-wrap .item span{
        font-size: 12px;
        padding: 5px 0px;
        margin-right: 5px;
        color: #FFF;
        border-radius: 3px;
    }
    .btn{
        height: 90%;
        margin: 10px 10px;
        background: #2c9a58;
        color: #FFF;
        height: 30px;
        line-height: 30px;
        border-radius: 5px;
        text-align: center;
        font-size: 16px;
    }
    .enable{
        background: #2c9a58;
        width: 70px;
    }
    .disable{
        background: #999;
        width: 50px;
    }

    .bottom{
        flex-grow: 1;
        display: flex;
        align-items: flex-end;
        justify-content: flex-end;
        img{
            width: 70%;
            object-fit: contain;
        }
    }

    .agreement{
        margin-top: 10px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-left: 15px;
        font-size: 14px;
        label{
            display: inline;
        }
    }

    .c{
        display: inline-block;
        margin: 0 2px;
    }

    .check{
        width: 16px;
        height: 16px;
        background: transparent url("../../../assets/img/check.png") no-repeat;
        background-size: 100% 100%;
    }
    .uncheck{
        width: 16px;
        height: 16px;
        background: transparent url("../../../assets/img/uncheck.png") no-repeat;
        background-size: 100% 100%;
    }
    .b{
        color: #2ba6bb;
    }
</style>

